module.exports = __webpack_public_path__ + "static/media/instagram_us.59d8a41b.png";